import { VENDORS_ACTIONS } from './vendors.types';
export const setVendorAction = (payload) => ({
    type: VENDORS_ACTIONS.SET_VENDOR,
    payload
});
export const setVendorsAction = (payload) => ({
    type: VENDORS_ACTIONS.SET_VENDORS,
    payload
});
export const setVendorOptionsAction = (payload) => ({
    type: VENDORS_ACTIONS.SET_VENDOR_OPTIONS,
    payload
});
export const setVendorsPaginatedAction = (payload) => ({
    type: VENDORS_ACTIONS.SET_VENDORS_PAGINATED,
    payload
});
export const setVendorsMetaAction = (payload) => ({
    type: VENDORS_ACTIONS.SET_VENDORS_META,
    payload
});
export const setVendorsStatusAction = (payload) => ({
    type: VENDORS_ACTIONS.SET_STATUS,
    payload
});
export const setVendorsErrorsAction = (payload) => ({
    type: VENDORS_ACTIONS.SET_ERRORS,
    payload
});
export const clearVendorsErrorsAction = () => ({
    type: VENDORS_ACTIONS.CLEAR_ERRORS
});
